import React, { FC } from 'react';
import { ReactComponent as MemoryIcon } from '../../icons/nav-links/memory.svg';
import './memory-empty-state.scss';

interface MemoryEmptyStateProps {
  variant:
    | 'unconfirmed'
    | 'aboutYou'
    | 'organisation'
    | 'relationships'
    | 'credentials';
}

const MemoryEmptyState: FC<MemoryEmptyStateProps> = ({ variant }) => {
  const getContent = () => {
    switch (variant) {
      case 'unconfirmed':
        return {
          title: 'No memories waiting for confirmation',
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
      case 'aboutYou':
        return {
          title: "There aren't any memories here yet",
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
      case 'organisation':
        return {
          title: "There aren't any memories here yet",
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
      case 'relationships':
        return {
          title: "There aren't any memories here yet",
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
      case 'credentials':
        return {
          title: 'No stored credentials',
          description:
            "When your Dreamies need to log in to a website on your behalf, they'll ask you for credentials which are stored securely in a vault.",
        };
    }
  };

  const content = getContent();

  return (
    <div className='memory-empty-state'>
      <div className='icon'>
        <MemoryIcon />
      </div>
      <h3 className='title'>{content.title}</h3>
      <p className='description'>{content.description}</p>
    </div>
  );
};

export default MemoryEmptyState;
